import mainPaseRranch from '@/views/branch/mainPase'
import branch from '@/views/branch'
import StarCaseindex from '@/components/cmd_center/star/Starindex.vue'
import shenhezhongList from '@/components/cmd_center/star/shenhezhongList.vue'  //审核中的案件
import underway from '@/components/cmd_center/star/underway.vue'  //进行中的案件
import newstar from '@/components/cmd_center/star/newstar.vue'  //新建星使派单
import starsdetail from '@/components/cmd_center/star/starsdetail.vue'  //星使详情
import starcompleted from '@/components/cmd_center/star/starcompleted.vue'  //已完成的案件
import refusedstar from '@/components/cmd_center/star/refusedstar.vue'  //拒绝启动的案件
import caserecord from '@/components/cmd_center/star/caserecord.vue'  //案件记录
import addcoordinator from '@/components/cmd_center/star/addcoordinator.vue'  //添加国内协调员
import coordinatorlist from '@/components/cmd_center/star/coordinatorlist.vue'  //协调员列表
import Familywealth from '@/components/cmd_center/star/Familywealth.vue' //家财险创建
import Exportrecords from '@/components/cmd_center/star/Exportrecords.vue' //家财险创建
import Homestart from '@/components/cmd_center/star/Homestart.vue'  //家财险案件管理
import Homestart3 from '@/components/cmd_center/star/Homestart3.vue'  //家财险案件管理
import Homestart1 from '@/components/cmd_center/star/Homestart1.vue'  //家财险案件管理
import Homestart2 from '@/components/cmd_center/star/Homestart2.vue'  //家财险案件管理
import Homestart4 from '@/components/cmd_center/star/Homestart4.vue'  //家财险案件管理
import rescueList from '@/components/cmd_center/star/rescueList.vue'  //救援案件列表
import rescueList2 from '@/components/cmd_center/star/rescueList2.vue'  //救援案件列表
import rescueList3 from '@/components/cmd_center/star/rescueList3.vue'  //救援案件列表
import rescueList4 from '@/components/cmd_center/star/rescueList4.vue'  //救援案件列表
import rescueList5 from '@/components/cmd_center/star/rescueList5.vue'  //救援案件列表
import createRescue from '@/components/cmd_center/star/createRescue.vue'  //救援案件创建
import createAcase from '@/components/cmd_center/star/createAcase.vue'  //救援案件创建
import Insurancemanagement from '@/components/cmd_center/star/Insurancemanagement.vue' //家财险保险机构管理
import helpStart from '@/components/cmd_center/helpStart.vue'
import draft from  '@/components/cmd_center/star/draftlist.vue'
import logPagelist from  '@/components/cmd_center/star/logPage.vue'
import draftdetails from  '@/components/cmd_center/star/draftdetails.vue'
import otherdraftdetails from  '@/components/cmd_center/otherdraftdetails.vue'
import Starenvoydetails from  '@/components/cmd_center/star/Starenvoydetails.vue'
// import Startingmechanism from '@/components/cmd_center/star/Startingmechanism.vue'
export default [
	{
		path: '/branch',
		name: 'branch',
		component: branch,
		redirect: 'mainPaseRranch',
		children: [{
				path: '/',
				name: 'mainPaseRranch',
				component: mainPaseRranch,
			},
      {
      	path: 'newstar1',
      	name: 'newstar1',
      	component: newstar,
      }, 
  		{
  			path: 'starindex',
  			name: 'StarCaseindex',
  			component: StarCaseindex,
  			children: [{
  				path: 'shenhezhongList',
  				name: 'shenhezhongList',
  				component: shenhezhongList
  			},
        // {
        //   path: 'Startingmechanism',
        //   name: 'Startingmechanism',
        //   component: Startingmechanism
        // },
        {
  				path: 'underway',
  				name: 'underway',
  				component: underway
  			}
        ,{
  				path: 'Familywealth',
  				name: 'Familywealth',
  				component: Familywealth,
        },
        {
  				path: 'Exportrecords',
  				name: 'Exportrecords',
  				component: Exportrecords,
        },
        {
  				path: 'draft',
  				name: 'draft',
  				component: draft,
        },
        {
  				path: 'logPage',
  				name: 'logPage',
  				component: logPagelist,
        },
        
        {
  				path: 'draftdetails',
  				name: 'draftdetails',
  				component: draftdetails,
        },
        {
  				path: 'otherdraftdetails',
  				name: 'otherdraftdetails',
  				component: otherdraftdetails,
        },
        {
  				path: 'Starenvoydetails',
  				name: 'Starenvoydetails',
  				component: Starenvoydetails,
        },
        
        {
  				path: 'Familywealth1',
  				name: 'Familywealth1',
  				component: Familywealth,
        },
        {
        path: 'Homestart',
        name: 'Homestart',
        component: Homestart,
      },
      {
        path: 'Homestart3',
        name: 'Homestart3',
        component: Homestart3,
      },
      {
        path: 'rescueList',
        name: 'rescueList',
        component: rescueList,
      },
      {
        path: 'rescueList2',
        name: 'rescueList2',
        component: rescueList2,
      },
      {
        path: 'rescueList5',
        name: 'rescueList5',
        component: rescueList5,
      },
      {
        path: 'rescueList3',
        name: 'rescueList3',
        component: rescueList3,
      },
      { 
        path: 'rescueList4',
        name: 'rescueList4',
        component: rescueList4,
      },
       {
        path: 'createRescue',
        name: 'createRescue',
        component: createRescue,
      },
      {
        path: 'createAcase',
        name: 'createAcase',
        component: createAcase,
      },
      {
        path: 'Insurancemanagement',
        name: 'Insurancemanagement',
        component: Insurancemanagement,
      },
      {
        path: "helpStart",
        name: 'helpStart',
        component: helpStart
      },
      {
        path: 'Homestart1',
        name: 'Homestart1',
        component: Homestart1,
      },
      {
        path: 'Homestart2',
        name: 'Homestart2',
        component: Homestart2,
      },
      {
        path: 'Homestart4',
        name: 'Homestart4',
        component: Homestart4,
      },
      {
        path: 'newstar',
        name: 'newstar',
        component: newstar,
      },{
        path: 'starsdetail',
        name: 'starsdetail',
        component: starsdetail,
      },{
        path: 'starcompleted',
        name: 'starcompleted',
        component: starcompleted,
      },{
        path: 'refusedstar',
        name: 'refusedstar',
        component: refusedstar,
      },{
        path: 'caserecord',
        name: 'caserecord',
        component: caserecord,
      },{
        path: 'addcoordinator',
        name: 'addcoordinator',
        component: addcoordinator,
      },{
        path: 'coordinatorlist',
        name: 'coordinatorlist',
        component: coordinatorlist,
      }]
  		}
		]
	},
  
]



// WEBPACK FOOTER //
// ./src/router/branch.js